export default "__VITE_ASSET__755501b6__"